import { c as _c } from "react/compiler-runtime";
import Grid from '@precis-digital/kurama/Grid';
import { type ReactElement } from 'react';
import { StyledFooterValue } from '../styled';
import type { CellAlignment } from '../types';
interface TableBodyDoubleLineCellProps {
  firstLine: string;
  secondLine: string;
  textAlign: CellAlignment;
}
export const TableBodyDoubleLineCell = t0 => {
  const $ = _c(9);
  const {
    firstLine,
    secondLine,
    textAlign
  } = t0;
  let t1;
  if ($[0] !== firstLine || $[1] !== textAlign) {
    t1 = <StyledFooterValue key="first-line" textAlign={textAlign}>{firstLine}</StyledFooterValue>;
    $[0] = firstLine;
    $[1] = textAlign;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== secondLine || $[4] !== textAlign) {
    t2 = <StyledFooterValue key="second-line" variant="body2" textAlign={textAlign}>{secondLine}</StyledFooterValue>;
    $[3] = secondLine;
    $[4] = textAlign;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <Grid container={true} direction="column" alignItems="start" justifyContent="center">{t1}{t2}</Grid>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default TableBodyDoubleLineCell;